import React, { useCallback, useMemo } from 'react'
import MappingForm from './Components/MappingForm'
import MappingList from './Components/MappingList'
import MappingHeader from '../Shared/Components/MappingHeader'
import StatusBanner from '../Shared/Components/StatusBanner'
import useSalesPersonMapping, { isRowComplete } from './useSalesPersonMapping'
import Shared from '../Shared/mappingUi.module.css'

const SalesPersonMapping = ({ connectorId }) => {
    const {
        erpSalesPersons,
        ecommerceSalesPersons,
        rows,
        isLoading,
        loadError,
        isSaving,
        saveStatus,
        addRow,
        updateRow,
        removeRow,
        submitMappings,
        dismissStatus
    } = useSalesPersonMapping(connectorId)

    const completeRowCount = useMemo(() => rows.filter(isRowComplete).length, [rows])
    const hasIncompleteRow = completeRowCount !== rows.length

    const isDuplicateErpCode = useCallback(
        (code) => rows.some((row) => row.erpSalesPersonCode === code),
        [rows]
    )

    const isBusy = isLoading || isSaving

    return (
        <>
            <MappingHeader
                title="Sales Person Mapping"
                countLabel={!isLoading && !loadError ? `${completeRowCount} mapped` : ''}
                isSaving={isSaving}
                isDisabled={isLoading || Boolean(loadError)}
                onSubmit={submitMappings}
            />

            <div className={`card-body p-10 ${Shared.body}`}>
                <StatusBanner status={saveStatus} onDismiss={dismissStatus} />

                <MappingForm
                    erpSalesPersons={erpSalesPersons}
                    ecommerceSalesPersons={ecommerceSalesPersons}
                    isDisabled={isBusy || Boolean(loadError)}
                    isDuplicate={isDuplicateErpCode}
                    onAdd={addRow}
                />

                {hasIncompleteRow ? (
                    <p className={Shared.hint}>
                        <i className="uil-info-circle" aria-hidden="true" />
                        {' '}Rows with an empty sales person are skipped when you submit.
                    </p>
                ) : null}

                <MappingList
                    rows={rows}
                    erpSalesPersons={erpSalesPersons}
                    ecommerceSalesPersons={ecommerceSalesPersons}
                    isLoading={isLoading}
                    loadError={loadError}
                    isDisabled={isSaving}
                    onChange={updateRow}
                    onRemove={removeRow}
                />
            </div>
        </>
    )
}

export default SalesPersonMapping
